export const Footer = () => (
  <footer data-testid="footer" className="border-t border-border">
    <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-6 py-12 sm:flex-row sm:items-center">
      <p className="font-sans text-sm font-medium tracking-[0.3em] uppercase">
        Lakeview Music
      </p>
      <p className="text-sm text-foreground/60">
        © 2026 Lakeview Music. All rights reserved.
      </p>
    </div>
  </footer>
);
